import IpsTagInput from './IpsTagInput.vue';
import '../../../styles/custom.scss';

export default IpsTagInput;
